(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Transparent header: manage .scrolled class + offset below announcement bar.
  (function () {
    var transparentHeader = null;
    var ticking = false;

    var cachedAboveHeight = null;

    function getAboveHeight() {
      // At scroll=0, getBoundingClientRect().top on the section-header gives
      // its exact visual y-position, which equals the announcement bar's visual height.
      // We cache it so resize events (when scrolled) don't read a sticky-snapped value.
      var sectionHeader = document.querySelector('.section-header');
      if (!sectionHeader) return 0;
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      if (cachedAboveHeight === null || scrollTop === 0) {
        cachedAboveHeight = Math.round(sectionHeader.getBoundingClientRect().top) + scrollTop;
      }
      return cachedAboveHeight;
    }

    function updateTop() {
      if (!transparentHeader) return;
      cachedAboveHeight = null; // force re-measure on resize
      var offset = getAboveHeight();
      document.documentElement.style.setProperty('--transparent-header-top', offset + 'px');
    }

    function handleScroll() {
      if (!transparentHeader) return;
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      if (scrollTop > 50) {
        transparentHeader.classList.add('scrolled');
      } else {
        transparentHeader.classList.remove('scrolled');
      }
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(handleScroll);
        ticking = true;
      }
    }

    function applyContentOffset() {
      // Pull the main content up by the section-header's flow height so the
      // hero/slideshow fills from behind the transparent header, not below it.
      var sectionHeader = document.querySelector('.section-header');
      var content = document.querySelector('.content-for-layout');
      if (sectionHeader && content) {
        content.style.marginTop = '-' + sectionHeader.offsetHeight + 'px';
      }
    }

    function init() {
      transparentHeader = document.querySelector('.header-wrapper.index-transparent');
      if (!transparentHeader) return;
      applyContentOffset();
      updateTop();
      handleScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', function() {
        applyContentOffset();
        updateTop();
      }, { passive: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  // Dropdown menus: keep [open] permanently on each <details> so the browser
  // always renders the disclosure. CSS :hover on the parent <li> controls what
  // the user sees. A MutationObserver re-adds [open] if Dawn's close() removes
  // it (e.g. on focusout or sticky-header scroll events).
  (function () {
    function init() {
      document.querySelectorAll('.header__inline-menu header-menu').forEach(function (menu) {
        var details = menu.querySelector('details');
        if (!details) return;
        var summary = details.querySelector('summary');

        details.setAttribute('open', '');
        new MutationObserver(function () {
          if (!details.hasAttribute('open')) details.setAttribute('open', '');
        }).observe(details, { attributes: true, attributeFilter: ['open'] });

        if (summary) {
          summary.addEventListener('click', function (e) {
            e.preventDefault();
            var url = summary.dataset.url;
            if (url && url !== '#' && url !== '') {
              window.location.href = url;
            }
          });
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();


  } catch(e) { console.error(e); }
})();
})();
